// extracted by mini-css-extract-plugin
export var footerContainer = "T_cR";
export var footerContent = "T_cT";
export var footerDisclosure = "T_cV";
export var menu = "T_cS";